import React from 'react';
import { TextField, Typography, Box, Tooltip, IconButton } from '@mui/material';
import { Info } from '@mui/icons-material';
import { DatePicker } from '@mui/x-date-pickers';
import { FORM_STYLES } from '../../styles/formStyles';

interface ResponsiveInputProps {
  label: string;
  value: any;
  onChange: (value: any) => void;
  onBlur?: () => void;
  type?: 'text' | 'number' | 'date' | 'email';
  placeholder?: string;
  unit?: string;
  fullWidth?: boolean;
  infoText?: string;
  required?: boolean;
  error?: boolean;
  helperText?: string;
  autoComplete?: string;
}

export const ResponsiveInput: React.FC<ResponsiveInputProps> = ({
  label,
  value,
  onChange,
  onBlur,
  type = 'text',
  placeholder,
  unit,
  fullWidth = true,
  infoText,
  required = false,
  error = false,
  helperText,
  autoComplete
}) => {
  const renderInput = () => {
    if (type === 'date') {
      return (
        <DatePicker
          value={value || null}
          onChange={(newValue) => onChange(newValue)}
          slotProps={{
            textField: {
              fullWidth: fullWidth,
              sx: FORM_STYLES.input.base,
              placeholder: placeholder || 'Välj datum'
            }
          }}
        />
      );
    }

    return (
      <TextField
        fullWidth={fullWidth}
        type={type}
        value={value || ''}
        onChange={(e) => {
          const newValue = type === 'number' ? +e.target.value : e.target.value;
          onChange(newValue);
        }}
        onBlur={onBlur}
        placeholder={placeholder}
        error={error}
        helperText={helperText}
        autoComplete={autoComplete}
        sx={FORM_STYLES.input.base}
      />
    );
  };

  return (
    <Box sx={{ flex: fullWidth ? 1 : 'none' }}>
      <Box sx={{ display: 'flex', alignItems: 'baseline', mb: 1 }}>
        <Typography sx={FORM_STYLES.label}>
          {label} {unit && `(${unit})`} {required && <span style={{ color: '#dc2626' }}>*</span>}
        </Typography>
        {infoText && (
          <Tooltip 
            title={infoText} 
            placement="top"
            arrow
          >
            <IconButton 
              size="small" 
              sx={{ 
                width: 24, 
                height: 24,
                ml: 1,
                color: '#6B7280',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                alignSelf: 'flex-start',
                mt: '-2px',
                '&:hover': {
                  color: '#4B5563',
                  backgroundColor: 'rgba(107, 114, 128, 0.1)'
                }
              }}
            >
              <Info sx={{ fontSize: 16 }} />
            </IconButton>
          </Tooltip>
        )}
      </Box>
      {renderInput()}
    </Box>
  );
}; 